module.exports = __webpack_public_path__ + "img/Image1.209cca46.png";